import { type MetaFunction } from '@remix-run/node'
import newyorkcentralmutual from './newyorkcentralmutual.png'

export const meta: MetaFunction = () => [
	{ title: 'New York Central Mutual' },
	{
		name: 'description',
		content: 'We offer insurance from New York Central Mutual.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">New York Central Mutual</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img
					src={newyorkcentralmutual}
					alt="New York Central Mutual"
					className="w-64"
				/>
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					New York Central Mutual Insurance was started in 1899 by VanNess
					Robinson in Edmeston, NY.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					The main focus of NYCM insurance is on personal insurance, including
					homeowner's, automobile, and umbrella. Coverage for boats,
					snowmobiles, and other toys is available through the homeowner's
					policy. In addition to the personal lines products, there are also
					some light commercial programs for your small business.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best has awarded NYCM Insurance with a rating of (A+) Superior
					due to its superior ability to meet its ongoing obligations to
					policyholders.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a href="https://nycm.com" target="_blank" rel="noopener noreferrer">
						https://nycm.com (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					(800) 234-6926
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="New York Central Mutual Payment"
						href="https://nycm.com/payment/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://nycm.com/payment/ (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					1899 Central Plaza East
					<br />
					Edmeston, NY 13335
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					New York Central Mutual Insurance Company
					<br />
					1899 Central Plaza East
					<br />
					Edmeston, NY 13335
				</p>
			</section>
		</main>
	)
}
